import { render, staticRenderFns } from "./CyberRiskAwareService.vue?vue&type=template&id=65715056&"
import script from "./CyberRiskAwareService.vue?vue&type=script&lang=js&"
export * from "./CyberRiskAwareService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports